<template>
    <div class="box-offset">
        <div class="box-ttl-wrap">
            <div class="box-ttl ">
                Welcome
            </div>
        </div>
        <div>
            <p>
                Thank you for your application. At this time your application is still being reviewed by our team. A member of ORNA will contact you once a position becomes available.
            </p>
            <p>
                If you would like to schedule an appointment for interview click the link below. If you have already scheduled your interview or completed your interview, please disregard.
            </p>
            <p>
                In the meantime please ensure your contact information (such as phone number and address) are always kept up to date on this profile so that we can properly offer you shifts when they become available.
            </p>
            <div class="row">
                <div class="col-lg-6">
                    <button  @click="redirectToPersonal" class="btn btn--secondary w-100 mb-4">
                        Click here to update your personal information
                    </button>
                </div>
                <div class="col-lg-6">
                    <button @click="showAppointmentBlock" class="btn w-100 mb-4">
                        Click here to Access the appointment
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WelcomeBlock',
    emits: [ 'open-appointment' ],
    data() {
        return {

        }
    },
    methods: {
        redirectToPersonal() {
            setTimeout(() => {
                const url = new URL(window.location);
                url.searchParams.set('tab', 'Personal');
                window.location.href = url.href;
            }, 1000)
        },
        showAppointmentBlock() {
            this.$emit('open-appointment', true)
        }
    }
}

</script>



<style scoped>

</style>
